// 870b24123758df93ad9abd7ed569089df03fe856|name=EmailDraftRequest|schemaHash=54f38b137ab42cc27904cc925851b3c5b1cfa37a|kind=parser-js

import { setDefinedValue } from '@myre/common-primitives';

import { parseEmailDraftContentFromJSON, parseEmailDraftContentToJSON } from './EmailDraftContent';

export function parseEmailDraftRequestFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'currentContent',
    parseEmailDraftContentFromJSON(
      _data.currentContent
    ),
  );
  setDefinedValue(result, 'instruction', _data.instruction);
  setDefinedValue(result, 'selectedText', _data.selectedText);

  return result;
}

export function parseEmailDraftRequestToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'currentContent',
    parseEmailDraftContentToJSON(
      _data.currentContent
    ),
  );
  setDefinedValue(result, 'instruction', _data.instruction);
  setDefinedValue(result, 'selectedText', _data.selectedText);

  return result;
}
